export const topicKeys = {
  all: ["topics"] as const,
  list: () => [...topicKeys.all, "list"] as const,
};
